import Form from "../../componets/Form";


export default function Section7() {
  return (
    <Form />
  );
}
